import React from 'react';

const BackgroundTexture: React.FC = () => {
  return (
    <div className="fixed inset-0 pointer-events-none" style={{ zIndex: -2 }}>
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: 'url(/assets/bg.jpg)' }} />
      <div className="absolute inset-0 bg-cream-50/55" />
      <div className="absolute inset-0 bg-gradient-to-b from-cream-50/40 via-cream-50/55 to-cream-50/75" />
    </div>
  );
};

export default BackgroundTexture;
